module.exports = __webpack_public_path__ + "img/mode-2.1866d81a.png";